export const DOCUMENTS = 'Documents';
export const ORGANIZATION_DOCUMENTS = 'Organization Documents';
export const DEFAULT = 'DEFAULT';
